import { render } from "./OtpPage.vue?vue&type=template&id=40a35477&scoped=true"
import script from "./OtpPage.vue?vue&type=script&lang=js"
export * from "./OtpPage.vue?vue&type=script&lang=js"

import "./OtpPage.vue?vue&type=style&index=0&id=40a35477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a35477"]])

export default __exports__